import { render } from "./ExamStudentDeleteModal.vue?vue&type=template&id=39c35714"
import script from "./ExamStudentDeleteModal.vue?vue&type=script&lang=js"
export * from "./ExamStudentDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__